export default __webpack_public_path__ + "static/media/skippedmeal@3x.bd0ea1ac.jpg";